import React, { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useIntl } from "react-intl";
import { Row, Col } from "antd";

import TooltipButton from "../../tooltipButton";
import {
  FILTER_RESET,
  FILTER_SET,
} from "../../../../../modules/redux/actionNames";

const FilterSubmit = ({ form, formName, filterState, onFilterClick }) => {
  const intl = useIntl();

  const dispatch = useDispatch();
  const handleSetFilterState = useCallback(
    (params) => {
      dispatch({
        type: FILTER_SET,
        state: {
          form: form.getFieldsValue(),
          data: params,
        },
        name: formName,
      });
    },
    [form, formName, dispatch]
  );
  const [formSet, setFormSet] = useState();
  useEffect(() => {
    if (!formSet) {
      setFormSet(true);
      filterState &&
        setTimeout(() => form.setFieldsValue(filterState.form), 500);
    }
  }, [form, formSet, filterState]);

  const handleReset = useCallback(() => {
    form.resetFields();
    dispatch({
      type: FILTER_RESET,
      name: formName,
    });
  }, [form, formName, dispatch]);

  const handleFiltering = useCallback(
    (e) => onFilterClick(e, handleSetFilterState),
    [onFilterClick, handleSetFilterState]
  );

  return (
    <Row type="flex" justify="end" gutter={5}>
      <Col>
        <TooltipButton
          icon="close"
          title={intl.formatMessage({
            id: "messages.clearForm",
            defaultMessage: "Vymazat formulář",
          })}
          onClick={handleReset}
        />
      </Col>
      <Col>
        <TooltipButton
          text={intl.formatMessage({
            id: "messages.filtering",
            defaultMessage: "Filtrovat",
          })}
          onClick={handleFiltering}
        />
      </Col>
    </Row>
  );
};

export default FilterSubmit;
